module.exports = __webpack_public_path__ + "img/shoot_00024.bea3953b.png";